import { transitionDomesticInsuranceDocumentsForm } from '../../../actions/domesticInsurance/Documents';
import { getDocumentsForm } from '../../../selectors/domesticInsurance/documents';

import { FIELD_STATUS } from '../../../reducers/status';
import { getSelectedCover } from '../../../selectors/domesticInsurance/quote';

export const documenetsFormRules = (store, next, action) => {
	const result = next(action);
	const documentsForm = getDocumentsForm(store.getState());
	const selectedCover = getSelectedCover(store.getState());
	const documentsFormValid = selectedCover.value !== 'House Only' ? validateDocumentsFormDetails(documentsForm) : validateHouseOnlyDocumentsFormDetails(documentsForm);
	
	const formAction = documentsFormValid
        ? transitionDomesticInsuranceDocumentsForm.formValid()
        : transitionDomesticInsuranceDocumentsForm.formInvalid();
	store.dispatch(formAction);
	return result;
};

const validateDocumentsFormDetails = (formFields) => {
	return (
		formFields.idUpload &&
		formFields.idUpload.status === FIELD_STATUS.VALID &&
		formFields.kraUpload &&
		formFields.kraUpload.status === FIELD_STATUS.VALID &&
		formFields.insuredItemsUpload &&
		formFields.insuredItemsUpload.status === FIELD_STATUS.VALID
	);
};

const validateHouseOnlyDocumentsFormDetails = (formFields) => {
	return (
		formFields.idUpload &&
		formFields.idUpload.status === FIELD_STATUS.VALID &&
		formFields.kraUpload &&
		formFields.kraUpload.status === FIELD_STATUS.VALID
	);
}

	
